// pages
import CreateReport from '../pages/reports/index.js';
//import Settings from '../pages/settings/index.js';
//import Price from '../pages/pricing/index.js';

// legacy pages
import Main from '../legacy/pages/Main/index.js'
import Aboutus from '../legacy/pages/Aboutus/index.js'
import Account from '../legacy/pages/Account/index.js'
import AdvertisersPage from '../legacy/pages/Advertisers/index.js'
import ASN from '../legacy/pages/ASN/index.js'
import ASNID from '../legacy/pages/ASNID/index.js'
import ASNWebsites from '../legacy/pages/ASNWebsites/index.js'
import TAGPage from '../legacy/pages/TAG/index.js'
import TAGID from '../legacy/pages/TAGID/index.js'
import TAGWebsites from '../legacy/pages/TAGWebsites/index.js'
import Blog from '../legacy/pages/Blog/index.js'
import Blogs from '../legacy/pages/Blogs/index.js'
import Bot from '../legacy/pages/Bot/index.js'
import Categories from '../legacy/pages/Categories/index.js'
import Category from '../legacy/pages/Category/index.js'
import CategoryTechnologies from '../legacy/pages/CategoryTechnologies/index.js'
import CategoryWebsites from '../legacy/pages/CategoryWebsites/index.js'
//import ChangePassword from '../legacy/pages/ChangePassword/index.js'
import Contactus from '../legacy/pages/Contactus/index.js'
import ScheduleDemo from '../legacy/pages/ScheduleDemo/index.js'
import CVE from '../legacy/pages/CVE/index.js'
import CVEAll from '../legacy/pages/CVEAll/index.js'
import CVELatest from '../legacy/pages/CVELatest/index.js'
import CVEs from '../legacy/pages/CVEs/index.js'
import CVEFullScan from '../legacy/pages/CVEFullScan/index.js'
import CVEFullScanResults from '../legacy/pages/CVEFullScanResults/index.js'
import CVEScan from '../legacy/pages/CVEScan/index.js'
import CVEScanResults from '../legacy/pages/CVEScanResults/index.js'
import CVEWebsites from '../legacy/pages/CVEWebsites/index.js'
import CWE from '../legacy/pages/CWE/index.js'
import CWEs from '../legacy/pages/CWEs/index.js'
import CWEWebsites from '../legacy/pages/CWEWebsites/index.js'
import FAQ from '../legacy/pages/FAQ/index.js'
import IPLookup from '../legacy/pages/IPLookup/index.js'
import IP from '../legacy/pages/IP/index.js'
import IPWebsites from '../legacy/pages/IPWebsites/index.js'
import ErrorRoutePage from '../legacy/pages/ErrorRoutePage/index.js'
import Monitoring from '../legacy/pages/Monitoring/index.js'
import MonitoringAddWebsite from '../legacy/pages/MonitoringAddWebsite/index.js'
import MonitoringWebsite from '../legacy/pages/MonitoringWebsite/index.js'
import MonitoringWebsites from '../legacy/pages/MonitoringWebsites/index.js'
import MonitoringSampleEmail from '../legacy/pages/MonitoringSampleEmail/index.js'
import Pricing from '../legacy/pages/Pricing/index.js'
import Privacy from '../legacy/pages/Privacy/index.js'
import RemoveDomain from '../legacy/pages/DomainRemoval/index.js'
import Report from '../legacy/pages/Report/index.js'
import ResponseHeader from '../legacy/pages/ResponseHeader/index.js'
import ResponseHeaders from '../legacy/pages/ResponseHeaders/index.js'
import ResponseHeaderWebsites from '../legacy/pages/ResponseHeaderWebsites/index.js'
//import ScanResults from '../legacy/pages/ScanResults/index.js'
import Search from '../legacy/pages/Search/index.js'
import Security from '../legacy/pages/Security/index.js'
import SuggestTechnology from '../legacy/pages/SuggestTechnology/index.js'
import Technology from '../legacy/pages/Technology/index.js'
import TechnologyChanges from '../legacy/pages/TechnologyChanges/index.js'
import TechnologyVersion from '../legacy/pages/TechnologyVersion/index.js'
import TechnologyVersions from '../legacy/pages/TechnologyVersions/index.js'
import TechnologyVersionWebsites from '../legacy/pages/TechnologyVersionWebsites/index.js'
import TechnologyWebsites from '../legacy/pages/TechnologyWebsites/index.js'
import Terms from '../legacy/pages/Terms/index.js'
import VerifiedDomainsAddDomain from '../legacy/pages/VerifiedDomainsAddDomain/index.js'
import VerifiedDomains from '../legacy/pages/VerifiedDomains/index.js'
import Website from '../legacy/pages/Website/index.js'
import WebsiteAdvertisers from '../legacy/pages/WebsiteAdvertisers/index.js'
import WebsiteAggregated from '../legacy/pages/WebsiteAggregated/index.js'
import WebsiteBacklinks from '../legacy/pages/WebsiteBacklinks/index.js'
import WebsiteBacklinksIPAddresses from '../legacy/pages/WebsiteBacklinksIPAddresses/index.js'
import WebsiteBacklinksWebsites from '../legacy/pages/WebsiteBacklinksWebsites/index.js'
import WebsiteHistory from '../legacy/pages/WebsiteHistory/index.js'
import WebsiteRedirects from '../legacy/pages/WebsiteRedirects/index.js'
import WebsiteScan from '../legacy/pages/WebsiteScan/index.js'
import WebsiteScanResults from '../legacy/pages/WebsiteScanResults/index.js'
import WebsiteSubdomains from '../legacy/pages/WebsiteSubdomains/index.js'
import WebsiteTechnologies from '../legacy/pages/WebsiteTechnologies/index.js'

// this pages lost their routes ... they are just 
/*
import CreateAccount from '../legacy/pages/CreateAccount/index.js'
import Login from '../legacy/pages/Login/index.js'
import Register from '../legacy/pages/Register/index.js'
import ResetPassword from '../legacy/pages/ResetPassword/index.js'
import SetPassword from '../legacy/pages/SetPassword/index.js'
*/

import React from 'react';

// Interface for route configuration
interface Route {
	path: string;
	exact: boolean;
	component: React.ComponentType<wts_approved_any>;
	pageTitle: string;
	pageDescription: string;
	loadServerData: boolean;
	noSSR?: boolean;
	addZeroPage?: boolean;
	page404?: boolean;
}

const routes: Route[] = [

  {
    path: '/',
    exact: true,
    component: Main,
    pageTitle: 'Main Page',
    pageDescription: 'Main Page',
    loadServerData: true
  },
  {
    path: '/about-us',
    exact: true,
    component: Aboutus,
    pageTitle: 'About Us',
    pageDescription: 'About Us',
    loadServerData: true
  },
  {
    path: '/advertisers',
    exact: true,
    component: AdvertisersPage,
    pageTitle: 'Advertiser Lookup',
    pageDescription: 'Advertiser Lookup',
    loadServerData: true
  }, 
  {
    path: '/asn',
    exact: true,
    component: ASN,
    pageTitle: 'ASN Lookup',
    pageDescription: 'ASN Lookup',
    loadServerData: true
  },
  {
    path: '/asn/:asn',
    exact: true,
    component: ASNID,
    pageTitle: 'ASN <asn>',
    pageDescription: 'ASN <asn>',
    loadServerData: true
  },
  {
    path: '/asn/:asn/websites/:page',
    exact: true,
    component: ASNWebsites,
    pageTitle: 'ASN <asn> websites',
    pageDescription: 'ASN <asn> websites',
    loadServerData: true
  },
  {
    path: '/asn/:asn/websites',
    exact: true,
    component: ASNWebsites,
    pageTitle: 'ASN <asn> websites',
    pageDescription: 'ASN <asn> websites',
    loadServerData: true,
    addZeroPage: true
  },
  {
    path: '/blog/:blogid',
    exact: true,
    component: Blog,
    pageTitle: 'Blog <blogid>',
    pageDescription: 'Blog <blogid>',
    loadServerData: true
  },
  {
    path: '/blog',
    exact: true,
    component: Blogs,
    pageTitle: 'Blogs',
    pageDescription: 'Blogs',
    loadServerData: true
  },
  {
    path: '/bot',
    exact: true,
    component: Bot,
    pageTitle: 'Bot',
    pageDescription: 'Bot',
    loadServerData: true
  }, 
  {
    path: '/contact-us',
    exact: true,
    component: Contactus,
    pageTitle: 'Contact Us',
    pageDescription: 'Contact Us',
    loadServerData: true,
  },
  {
    path: '/schedule-demo',
    exact: true,
    component: ScheduleDemo,
    pageTitle: 'Schedule a Demo',
    pageDescription: 'Schedule a Demo with WebTechSurvey',
    loadServerData: true,
  },
  {
    path: '/create-report',
    exact: true,
    component: CreateReport,
    pageTitle: 'Create Report',
    pageDescription: 'Create Report',
    loadServerData: true,
    noSSR: true
  },
  {
    path: '/domain-removal',
    exact: true,
    component: RemoveDomain,
    pageTitle: 'Domain Removal',
    pageDescription: 'Remove domain from our dataset',
    loadServerData: true
  },
  {
    path: '/user/account',
    exact: true,
    component: Account,
    pageTitle: 'Account Page',
    pageDescription: 'Account Page',
    loadServerData: true//,
    //noSSR: true
  },
  {
    path: '/user/verified-domains/add-domain',
    exact: true,
    component: VerifiedDomainsAddDomain,
    pageTitle: 'Add Verified Domain',
    pageDescription: 'Add Verified Domain',
    loadServerData: true//,
    //noSSR: true
  },
  {
    path: '/user/verified-domains',
    exact: true,
    component: VerifiedDomains,
    pageTitle: 'List of verified domains',
    pageDescription: 'List of verified domains',
    loadServerData: true//,
    //noSSR: true
  },
  {
    path: '/search',
    exact: true,
    component: Search,
    pageTitle: 'Search Page',
    pageDescription: 'Search Page',
    loadServerData: true
  },/*
  {
    path: '/settings/*',
    exact: true,
    component: Settings,
    pageTitle: 'Account Settings',
    pageDescription: 'Account Settings',
    loadServerData: false,
    noSSR: true
  },
  {
    path: '/price/',
    exact: true,
    component: Price,
    pageTitle: 'Price',
    pageDescription: 'Price',
    loadServerData: false,
    noSSR: true
  },*/
  {
    path: '/common-response-headers',
    exact: true,
    component: ResponseHeaders,
    pageTitle: 'Response Headers',
    pageDescription: 'Response Headers',
    loadServerData: true
  },
  {
    path: '/cve/all/:page',
    exact: true,
    component: CVEAll,
    pageTitle: 'All CVEs',
    pageDescription: 'CVE',
    loadServerData: true
  },
  {
    path: '/cve/all',
    exact: true,
    component: CVEAll,
    pageTitle: 'All CVEs',
    pageDescription: 'CVE',
    loadServerData: true
  },
  {
    path: '/cve/latest/:page',
    exact: true,
    component: CVELatest,
    pageTitle: 'Latest CVEs',
    pageDescription: 'CVE',
    loadServerData: true
  },  
  {
    path: '/cve/latest',
    exact: true,
    component: CVELatest,
    pageTitle: 'Latest CVEs',
    pageDescription: 'CVE',
    loadServerData: true
  },
  {
    path: '/cve/:cveid',
    exact: true,
    component: CVE,
    pageTitle: 'CVE',
    pageDescription: 'CVE',
    loadServerData: true
  },
  {
    path: '/cve-security-scan',
    exact: true,
    component: CVEFullScan,
    pageTitle: 'CVE Full Scan',
    pageDescription: 'CVE Full Scan',
    loadServerData: true,
  },
  {
    path: '/cve-security-scan/results',
    exact: true,
    component: CVEFullScanResults,
    pageTitle: 'CVE Full Scan Results',
    pageDescription: 'CVE Full Scan Results',
    loadServerData: true
  },
  {
    path: '/cve-security-scan/:cveid',
    exact: true,
    component: CVEScan,
    pageTitle: 'CVE Scan',
    pageDescription: 'CVE Scan',
    loadServerData: true,
  },
  {
    path: '/cve-security-scan/:cveid/results',
    exact: true,
    component: CVEScanResults,
    pageTitle: 'CVE Scan Results',
    pageDescription: 'CVE Scan Results',
    loadServerData: true
  },
  {
    path: '/cve',
    exact: true,
    component: CVEs,
    pageTitle: 'CVEs',
    pageDescription: 'CVEs',
    loadServerData: true
  },
  {
    path: '/cve/:cveid/websites/:page',
    exact: true,
    component: CVEWebsites,
    pageTitle: 'Website that have a vulnerable component',
    pageDescription: 'Website that have a vulnerable component',
    loadServerData: true
  },  
  {
    path: '/cve/:cveid/websites',
    exact: true,
    component: CVEWebsites,
    pageTitle: 'Website that have a vulnerable component',
    pageDescription: 'Website that have a vulnerable component',
    loadServerData: true,
    addZeroPage: true
  },
  {
    path: '/cwe/:cweid',
    exact: true,
    component: CWE,
    pageTitle: 'CWE',
    pageDescription: 'CWE',
    loadServerData: true
  },
  {
    path: '/cwe',
    exact: true,
    component: CWEs,
    pageTitle: 'CWEs Top 25',
    pageDescription: 'List of top 25 most critical software weaknesses.',
    loadServerData: true
  },
  {
    path: '/cwe/:cweid/websites/:page',
    exact: true,
    component: CWEWebsites,
    pageTitle: 'Website that have a vulnerable component',
    pageDescription: 'Website that have a vulnerable component',
    loadServerData: true
  },  
  {
    path: '/cwe/:cweid/websites',
    exact: true,
    component: CWEWebsites,
    pageTitle: 'Website that have a vulnerable component',
    pageDescription: 'Website that have a vulnerable component',
    loadServerData: true,
    addZeroPage: true
  },
  {
    path: '/faq',
    exact: true,
    component: FAQ,
    pageTitle: 'Frequently Asked Questions (FAQ)',
    pageDescription: 'Frequently Asked Questions (FAQ)',
    loadServerData: true
  },  
  {
    path: '/ip-lookup',
    exact: true,
    component: IPLookup,
    pageTitle: 'Reverse IP',
    pageDescription: 'Reverse IP',
    loadServerData: true
  },
  {
    path: '/ip/:ipaddress',
    exact: true,
    component: IP,
    pageTitle: 'IP Address <ip address>',
    pageDescription: 'IP Address <ip address>',
    loadServerData: true
  },
  {
    path: '/ip/:ipaddress/websites/:page',
    exact: true,
    component: IPWebsites,
    pageTitle: 'IP Address <ip address> websites',
    pageDescription: 'IP Address <ip address> websites',
    loadServerData: true
  },  
  {
    path: '/ip/:ipaddress/websites',
    exact: true,
    component: IPWebsites,
    pageTitle: 'IP Address <ip address> websites',
    pageDescription: 'IP Address <ip address> websites',
    loadServerData: true,
    addZeroPage: true
  },
  {
    path: '/monitoring',
    exact: true,
    component: Monitoring,
    pageTitle: 'Security monitoring solutions',
    pageDescription: 'Security monitoring solutions',
    loadServerData: true
  },  
  {
    path: '/monitoring/sample-notification-email',
    exact: true,
    component: MonitoringSampleEmail,
    pageTitle: 'Sample Monitoring Update Email',
    pageDescription: 'Sample Monitoring Update Email',
    loadServerData: true
  },  
  {
    path: '/monitoring/add-website',
    exact: true,
    component: MonitoringAddWebsite,
    pageTitle: 'Add domain for monitoring',
    pageDescription: 'Add domain for monitoring',
    loadServerData: true
  },  
  {
    path: '/monitoring/websites',
    exact: true,
    component: MonitoringWebsites,
    pageTitle: 'Monitored websites',
    pageDescription: 'Monitored websites',
    loadServerData: true
  },  
  {
    path: '/monitoring/:website',
    exact: true,
    component: MonitoringWebsite,
    pageTitle: 'Website Monitoring',
    pageDescription: 'Website Monitoring',
    loadServerData: true
  },  
  {
    path: '/privacy',
    exact: true,
    component: Privacy,
    pageTitle: 'Privacy page',
    pageDescription: 'Privacy page',
    loadServerData: true,
    noSSR: true
  },
  {
    path: '/pricing',
    exact: true,
    component: Pricing,
    pageTitle: 'Pricing page',
    pageDescription: 'Pricing page',
    loadServerData: true
  },
  {
    path: '/pricing',
    exact: true,
    component: Pricing,
    pageTitle: 'Pricing page',
    pageDescription: 'Pricing page',
    loadServerData: true
  },
  {
    path: '/reports/:reportId',
    exact: true,
    component: Report,
    pageTitle: 'Report',
    pageDescription: 'Report',
    loadServerData: true
  },
  {
    path: '/response-header/:header',
    exact: true,
    component: ResponseHeader,
    pageTitle: 'Response Header <header>',
    pageDescription: 'Response Header <header>',
    loadServerData: true
  },
  {
    path: '/response-header/:header/websites/:page',
    exact: true,
    component: ResponseHeaderWebsites,
    pageTitle: 'Response Header <header> websites',
    pageDescription: 'Response Header <header> websites',
    loadServerData: true
  },
  {
    path: '/response-header/:header/websites',
    exact: true,
    component: ResponseHeaderWebsites,
    pageTitle: 'Response Header <header> websites',
    pageDescription: 'Response Header <header> websites',
    loadServerData: true,
    addZeroPage: true
  },
  {
    path: '/security',
    exact: true,
    component: Security,
    pageTitle: 'Security Solutions',
    pageDescription: 'Security Solutions',
    loadServerData: true
  },
  {
    path: '/suggest-technology',
    exact: true,
    component: SuggestTechnology,
    pageTitle: 'Suggest Technology',
    pageDescription: 'Suggest new technology to be added to the WebTechSurvey analysis',
    loadServerData: true
  },
  {
    path: '/technology/:technologyid',
    exact: true,
    component: Technology,
    pageTitle: 'Technology <Name>',
    pageDescription: 'Technology <Name>',
    loadServerData: true
  },
  {
    path: '/technology/:technologyid/version/:versionid',
    exact: true,
    component: TechnologyVersion,
    pageTitle: 'Technology Version <Name>',
    pageDescription: 'Technology Version <Name>',
    loadServerData: true
  },
  {
    path: '/technology/:technologyid/versions',
    exact: true,
    component: TechnologyVersions,
    pageTitle: 'Technology <Name> versions',
    pageDescription: 'Technology <Name> versions',
    loadServerData: true
  },
  {
    path: '/technology/:technologyid/changes',
    exact: true,
    component: TechnologyChanges,
    pageTitle: 'Technology <Name> changes',
    pageDescription: 'Technology <Name> changes',
    loadServerData: true
  },
  {
    path: '/technology-type',
    exact: true,
    component: Categories,
    pageTitle: 'Categories',
    pageDescription: 'Categories',
    loadServerData: true
  },
  {
    path: '/technology-type/:categoryid',
    exact: true,
    component: Category,
    pageTitle: 'Category <Name>',
    pageDescription: 'Category <Name>',
    loadServerData: true
  },
  {
    path: '/technology-type/:categoryid/technologies/:page',
    exact: true,
    component: CategoryTechnologies,
    pageTitle: 'Category technologies',
    pageDescription: 'Category technologies',
    loadServerData: true
  },
  {
    path: '/technology-type/:categoryid/technologies',
    exact: true,
    component: CategoryTechnologies,
    pageTitle: 'Category <Name> websites',
    pageDescription: 'Category <Name> websites',
    loadServerData: true,
    addZeroPage: true
  },
  {
    path: '/technology-type/:categoryid/websites/:page',
    exact: true,
    component: CategoryWebsites,
    pageTitle: 'Category <Name> websites',
    pageDescription: 'Category <Name> websites',
    loadServerData: true
  },
  {
    path: '/technology-type/:categoryid/websites',
    exact: true,
    component: CategoryWebsites,
    pageTitle: 'Category <Name> websites',
    pageDescription: 'Category <Name> websites',
    loadServerData: true,
    addZeroPage: true
  },
  // {
  //   path: '/user/change-password',
  //   exact: true,
  //   component: ChangePassword,
  //   pageTitle: 'ChangePassword Page',
  //   pageDescription: 'ChangePassword Page',
  //   loadServerData: false,
  //   noSSR: true
  // },  
  {
    path: '/terms',
    exact: true,
    component: Terms,
    pageTitle: 'Terms',
    pageDescription: 'Terms',
    loadServerData: true,
    noSSR: true
  },  
  {
    path: '/website/:websiteid',
    exact: true,
    component: Website,
    pageTitle: 'Website <Name>',
    pageDescription: 'Website <Name>',
    loadServerData: true
  },
  {
    path: '/website/:websiteid/aggregated',
    exact: true,
    component: WebsiteAggregated,
    pageTitle: 'Aggregated Website <Name>',
    pageDescription: 'Aggregated Website <Name>',
    loadServerData: true
  },
  {
    path: '/website/:websiteid/backlinks',
    exact: true,
    component: WebsiteBacklinks,
    pageTitle: 'Website <Name> backlinks',
    pageDescription: 'Website <Name> backlinks',
    loadServerData: true
  },
  {
    path: '/website/:websiteid/history/:page',
    exact: true,
    component: WebsiteHistory,
    pageTitle: 'Website <Name> history',
    pageDescription: 'Website <Name> history',
    loadServerData: true
  },
  {
    path: '/website/:websiteid/history',
    exact: true,
    component: WebsiteHistory,
    pageTitle: 'Website <Name> history',
    pageDescription: 'Website <Name> history',
    loadServerData: true,
    addZeroPage: true
  },
  {
    path: '/website/:websiteid/backlinks/websites/:page',
    exact: true,
    component: WebsiteBacklinksWebsites,
    pageTitle: 'Website <Name> history',
    pageDescription: 'Website <Name> history',
    loadServerData: true
  },
  {
    path: '/website/:websiteid/backlinks/websites',
    exact: true,
    component: WebsiteBacklinksWebsites,
    pageTitle: 'Website <Name> backlinking websites',
    pageDescription: 'Website <Name> backlinking websites',
    loadServerData: true,
    addZeroPage: true
  },
  {
    path: '/website/:websiteid/backlinks/ipaddresses/:page',
    exact: true,
    component: WebsiteBacklinksIPAddresses,
    pageTitle: 'Website <Name> backlinking ip addresses',
    pageDescription: 'Website <Name> backlinking  ip addresses',
    loadServerData: true
  },
  {
    path: '/website/:websiteid/backlinks/ipaddresses',
    exact: true,
    component: WebsiteBacklinksIPAddresses,
    pageTitle: 'Website <Name> backlinking ip addresses',
    pageDescription: 'Website <Name> backlinking  ip addresses',
    loadServerData: true,
    addZeroPage: true
  },
  {
    path: '/website/:websiteid/subdomains/:page',
    exact: true,
    component: WebsiteSubdomains,
    pageTitle: 'Website <Name> subdomains',
    pageDescription: 'Website <Name> subdomains',
    loadServerData: true
  },
  {
    path: '/website/:websiteid/subdomains',
    exact: true,
    component: WebsiteSubdomains,
    pageTitle: 'Website <Name> subdomains',
    pageDescription: 'Website <Name> subdomains',
    loadServerData: true,
    addZeroPage: true
  },
  {
    path: '/website/:websiteid/redirects/:page',
    exact: true,
    component: WebsiteRedirects,
    pageTitle: 'Website <Name> redirects',
    pageDescription: 'Website <Name> redirects',
    loadServerData: true
  },
  {
    path: '/website/:websiteid/redirects',
    exact: true,
    component: WebsiteRedirects,
    pageTitle: 'Website <Name> redirects',
    pageDescription: 'Website <Name> redirects',
    loadServerData: true,
    addZeroPage: true
  },
  {
    path: '/website/:websiteid/technologies/:page',
    exact: true,
    component: WebsiteTechnologies,
    pageTitle: 'Website <Name> technologies',
    pageDescription: 'Website <Name> technologies',
    loadServerData: true
  },
  {
    path: '/website/:websiteid/technologies',
    exact: true,
    component: WebsiteTechnologies,
    pageTitle: 'Website <Name> technologies',
    pageDescription: 'Website <Name> technologies',
    loadServerData: true,
    addZeroPage: true
  },
  {
    path: '/website/:websiteid/advertisers/:page',
    exact: true,
    component: WebsiteAdvertisers,
    pageTitle: 'Website <Name> technologies',
    pageDescription: 'Website <Name> technologies',
    loadServerData: true
  },
  {
    path: '/website/:websiteid/advertisers',
    exact: true,
    component: WebsiteAdvertisers,
    pageTitle: 'Website <Name> advertisers',
    pageDescription: 'Website <Name> advertisers',
    loadServerData: true,
    addZeroPage: true
  },
  {
    path: '/technology-scan/results',
    exact: true,
    component: WebsiteScanResults,
    pageTitle: 'Website Technology Scan Results',
    pageDescription: 'Website Technology Scan Results',
    loadServerData: true,
  },
  {
    path: '/technology-scan',
    exact: true,
    component: WebsiteScan,
    pageTitle: 'Website Technology Scan',
    pageDescription: 'Website Technology Scan',
    loadServerData: true
  },
  {
    path: '/tag',
    exact: true,
    component: TAGPage,
    pageTitle: 'Tag ID Lookup',
    pageDescription: 'Tag ID Lookup',
    loadServerData: true
  },
  {
    path: '/tag/:tag',
    exact: true,
    component: TAGID,
    pageTitle: 'Tag ID <tag>',
    pageDescription: 'Tag ID <tag>',
    loadServerData: true
  },
  {
    path: '/tag/:tag/websites/:page',
    exact: true,
    component: TAGWebsites,
    pageTitle: 'Tag <tag> websites',
    pageDescription: 'Tag <tag> websites',
    loadServerData: true
  },
  {
    path: '/tag/:tag/websites',
    exact: true,
    component: TAGWebsites,
    pageTitle: 'Tag <tag> websites',
    pageDescription: 'Tag <tag> websites',
    loadServerData: true,
    addZeroPage: true
  },
  {
    path: '/technology/:technologyid/websites/:page',
    exact: true,
    component: TechnologyWebsites,
    pageTitle: 'Technology <Name> websites',
    pageDescription: 'Technology <Name> websites',
    loadServerData: true
  },
  {
    path: '/technology/:technologyid/websites',
    exact: true,
    component: TechnologyWebsites,
    pageTitle: 'Technology <Name> websites',
    pageDescription: 'Technology <Name> websites',
    loadServerData: true,
    addZeroPage: true
  },
  {
    path: '/technology/:technologyid/version/:version/websites/:page',
    exact: true,
    component: TechnologyVersionWebsites,
    pageTitle: 'Technology <Name> Version <Version> websites',
    pageDescription: 'Technology <Name> Version <Version> websites',
    loadServerData: true
  },
  {
    path: '/technology/:technologyid/version/:version/websites',
    exact: true,
    component: TechnologyVersionWebsites,
    pageTitle: 'Technology <Name> Version <Version> websites',
    pageDescription: 'Technology <Name> Version <Version> websites',
    loadServerData: true,
    addZeroPage: true
  },
  {
    path: '*',
    exact: false,
    component: ErrorRoutePage,
    pageTitle: 'Error',
    pageDescription: 'Error',
    loadServerData: false,
    noSSR: true,
    page404: true
  }
];
/*
const ServerRoutes = routes;
const ClientRoutes = 
[
  ...routes,
  // Server routes + 404 route 
  {
    path: '*',
    exact: true,
    component: NotFoundPage,
    pageTitle: 'Page not found',
    pageDescription: 'Page not found',
    loadServerData: false
  }
];
*/
export default routes;
/*
export default  {
  ServerRoutes,
  ClientRoutes 
}
*/
